import { TransferToAgentItem } from '../transferToAgentDropdown';

/**
 * Compare function that are used to sort TransferToAgentItem's so that the
 * status working will be sorted before status away.
 *
 * @param a The left side TransferToAgentItem
 * @param b The right side TransferToAgentItem
 * @returns Number - negative, positive or neutral
 */
export function comparePresenceStatus(
  a: TransferToAgentItem,
  b: TransferToAgentItem,
): number {
  if (a.status.toLowerCase() === 'working') {
    return -1;
  }

  if (b.status.toLowerCase() === 'away') {
    return 1;
  }

  return 0;
}
